<template>
    <span v-if="value && value.length > 0">
        <a
            class="pr-1"
            v-if="innerHideInfo"
            @click.prevent="innerInfoIsHidden = !innerInfoIsHidden"
        >
            <b-icon
                v-if="!innerInfoIsHidden"
                size="is-small"
                icon="eye-off-outline"
                type="is-danger"
            />
            <b-icon v-if="innerInfoIsHidden" size="is-small" icon="eye-outline" type="is-success" />
        </a>
        <span v-html="InnerValue"></span>
    </span>
</template>

<script>
/*
Adicionar no componente pai

Adicionar dentro do <h1 class="title">
  <a 
    class="pl-1"
    v-if="hide.hideInfo"
    @click="infoIsHidden()"
  >
    <b-icon v-if="!hide.infoIsHidden" icon="eye-off-outline" type="is-danger"/>
    <b-icon v-if="hide.infoIsHidden" icon="eye-outline" type="is-success"/> 
  </a>

// Componente
<HideInfo v-if="!hide.cleanHide" :value="" :infoIsHidden="hide.infoIsHidden" />

import HideInfo from "@/components/shared/HideInfo";

Adicionar no data()
  cleanHide: true,

Adicionar no updatePagination()
  this.cleanHide = true;

Adicionar no .finally do carregarDados()
  this.cleanHide = false;
*/
export default {
    props: {
        // Valor/texto da informação
        value: {
            type: String,
            default: '',
        },
        // Caso queira mostrar a informação deixar como false
        hideInfo: {
            type: Boolean,
            default: true,
        },
        // Mostrar uma parte da informação
        showPartInfo: {
            type: Boolean,
            default: true,
        },
        // Mostrar do início ou fim; Valores aceitos: start/end
        showPartInfoPosition: {
            type: String,
            default: 'start',
        },
        // Quantidade a ser mostrada
        showPartInfoLenght: {
            type: Number,
            default: 3,
        },
        // Situação da visualização da informação
        infoIsHidden: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            innerHideInfo: this.hideInfo,
            innerInfoIsHidden: this.infoIsHidden,
            InnerValue: this.value.trim(),
            innerShowPartInfoLenght: this.showPartInfoLenght,
            startValue: null,
            endValue: null,
        };
    },
    created() {
        // Se for esconder a informação, inicia-se a função
        if (this.innerHideInfo) this.toogleHide();
    },
    watch: {
        // caso queira pode-se mudar pelo componente pai a ativação do componente
        hideInfo(val) {
            this.innerHideInfo = val;
        },
        infoIsHidden(val) {
            this.innerInfoIsHidden = val;
        },
        innerInfoIsHidden() {
            if (this.innerHideInfo) this.toogleHide();
        },
    },
    methods: {
        toogleHide() {
            if (this.innerInfoIsHidden) {
                if (this.showPartInfo) {
                    if (this.value.trim().length <= this.innerShowPartInfoLenght) {
                        this.innerShowPartInfoLenght = Math.trunc(this.value.trim().length / 2);
                    }

                    // &bullet; é a tag html para o ponto mostrado como máscara
                    this.InnerValue = ' &bullet;'.repeat(
                        this.value.trim().length - this.innerShowPartInfoLenght
                    );

                    if (this.showPartInfoPosition == 'start') {
                        this.startValue = this.value.trim().substr(0, this.innerShowPartInfoLenght);
                        this.InnerValue = this.startValue + '' + this.InnerValue;
                    } else if (this.showPartInfoPosition == 'end') {
                        this.endValue = this.value
                            .trim()
                            .substr(
                                this.value.trim().length - this.innerShowPartInfoLenght,
                                this.innerShowPartInfoLenght
                            );
                        this.InnerValue = this.InnerValue + ' ' + this.endValue;
                    }
                } else {
                    this.InnerValue = ' &bullet;'.repeat(this.value.trim().length);
                }
            } else {
                this.InnerValue = this.value.trim();
            }
        },
    },
};
</script>

<style>
a {
    display: inline;
}
</style>
